export default __webpack_public_path__ + "static/media/pets_live.55c249c1.svg";